import { Redirect, Route } from 'react-router-dom';
import {  getSignupTokenCookie } from './Storage';

export default function SignupRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>{
        return getSignupTokenCookie()? (
          <Component {...props} />
        ) : (
          <Redirect to="/auth/otp" />
        )
      }
        
      }
    />
  );
}
